import { render, staticRenderFns } from "./RainEstimationHistoricalData.vue?vue&type=template&id=5e4ed4f7&scoped=true"
import script from "./RainEstimationHistoricalData.vue?vue&type=script&lang=js"
export * from "./RainEstimationHistoricalData.vue?vue&type=script&lang=js"
import style0 from "./RainEstimationHistoricalData.vue?vue&type=style&index=0&id=5e4ed4f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4ed4f7",
  null
  
)

export default component.exports